
export default {
    default: 'users',
    selectById: 'users/:id',
    paging: 'users/paging',
    agendaConfig: 'users/:id/agendaconfig',
    quicksearch: 'users/quicksearch',
    managers: 'users/getidnames',
    authConfig: 'users/auth-config',
    configs: 'users/configs',
    qrCode: 'users/qrcode',
    sendQRCode: 'users/sendQRCode',
    userConfigurationInformation: 'user-configs/info',
    userConfiguration: 'user-configs',

    // NEW API
    information: 'users/:id/information',
    updateInfo: 'users/:id',
    configuration: 'configurations/user-configuration',
    twoFactorLoginConfig: 'users/two-factor-login-config',
    generateQRCode: 'users/generate-qrcode-two-factor-login',
    verifyQRCode: 'users/verify-qrcode-two-factor-login',
    copyAgendaConfig: 'configurations/user-configuration/copy-agenda',
    changePasswordUser: "users/:id/change-password",
    getNotificationConfig: '/configurations/notification-configuration',
    
    getCompaniesList: '/configurations/get-business-supplier-list/Immowinkel',
    registerRealEstateAgent: '/configurations/register-smooved',
    userConfigurationEX: 'configurations/user-configuration',
    userGenerateToken: '/user-configs/generateToken',
    userPrepareRegisterAccount: 'user-configs/exchange/prepare-register-account',
    userApplyRegisterAccount: 'user-configs/exchange/apply-register-account',
    getBusinessList: 'configurations/get-business-supplier-list/Korfine?apiKey=:apiKey',
    configurationsRegisterAccount: 'configurations/register-account/:supplierName',
    configurationsExternalService: 'configurations/external-service-accounts',
    configurationsRegisterAccountSave: 'configurations/register-account-and-save/:supplierName',
    saveConfigurationsExternalService: '/configurations/external-services',
    getConfigurationsUserRights: '/configurations/user-rights',

    // Invoicing service endpoints
    registerInvoicingMethod: 'configurations/register-invoicing-method',
    getInvoicingMethod: 'configurations/invoicing-method',
}